(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/visit-game-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/visit-game-button.js');

'use strict';

const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const {
  useWagers
} = svs.components.marketplaceCompetition.services.hooks;
const {
  getOngoingBetPath
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  REG_CLOSED_DRAW_FINALIZED
} = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates;
const {
  preventDoubleClick
} = svs.components.lbUtils;
const VisitGameButton = _ref => {
  var _wagers$currentDrawNu;
  let {
    competition,
    label
  } = _ref;
  const history = useHistory();
  const wagers = useWagers(competition.id);
  let currentDrawNumber = competition === null || competition === void 0 ? void 0 : competition.details.currentDrawNumber;
  if (competition.status === REG_CLOSED_DRAW_FINALIZED) {
    currentDrawNumber = currentDrawNumber - 1;
  }
  const wagerSerial = wagers === null || wagers === void 0 || (_wagers$currentDrawNu = wagers[currentDrawNumber]) === null || _wagers$currentDrawNu === void 0 ? void 0 : _wagers$currentDrawNu.wagerSerial;
  const path = getOngoingBetPath(competition, wagerSerial);
  const handleClick = () => {
    if (path) {
      history.push(path);
    }
  };

  const wrappedOnClick = preventDoubleClick(handleClick);
  return React.createElement("div", {
    className: "overview-hero-button-container"
  }, React.createElement(Button, {
    "aria-label": label,
    className: "button-250 qa-competition-overview-hero-open-game-button qa-to-competition-live-bet",
    href: path,
    onClick: e => {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
      }
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      wrappedOnClick(e);
    }
  }, label));
};
VisitGameButton.defaultProps = {
  label: 'Till spelet'
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.VisitGameButton', VisitGameButton);

 })(window);